<template>
    <v-container>
        <v-card style="border-radius: 8px;">
            <v-layout>
                <v-flex xs3 class="mt-3 ml-4">
                     <div class="title font-weight-regular mt-3"> Get started greeting note</div>
                </v-flex>
                <v-flex xs4 class="mt-3 ml-4">
                    <v-textarea
                        label="Greeting note"
                        outline
                        rows="3"
                        auto-grow
                        v-model="cgnote[0].text"
                        counter="160"
                    ></v-textarea>
                    <v-btn flat round class="mt-2" color="primary" @click="saveGnote">Save</v-btn>
                </v-flex>
                <v-flex xs4 class="mt-3 ml-4">
                    <div>
                        <h3 class="subheading">Supported personalised variables</h3>
                        <div class="caption grey--text">{{user_first_name}}</div>
                        <div class="caption grey--text">{{user_last_name}}</div>
                        <div class="caption grey--text">{{user_full_name}}</div>
                    </div> 
                </v-flex>
            </v-layout>
        </v-card>       
    </v-container>
</template>

<script>

export default {
    data(){
        return{
           gnote:null,
           user_first_name:"{{user_first_name}}",
           user_last_name:"{{user_last_name}}",
           user_full_name:"{{user_full_name}}"
        }
    },
    methods:{
        saveGnote(){
            let udatedNote = this.cgnote
            let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "greeting": udatedNote
                    },
                    function (response) {
                        console.log(response)           
                    });
                    
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
        },  
    },
    computed:{
        cgnote(){
            if (this.$store.state.pageDetails.greeting != undefined){
                    this.gnote = this.$store.state.pageDetails.greeting
                    console.log(this.gnote)
                return this.gnote
             }
             else{
                 this.gnote = [ {
                    "locale":"default",
                    "text":"Welcome to "+this.$store.state.pageDetails.name
                    }
                ]
                 return this.gnote
             }
        }
        
    }      
}
</script>
